import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/i18n' // Initialize i18n
import App from './App.tsx'
import { visitorBeacon } from './lib/visitorBeacon'

// Notify backend of visitor arrival (fires once per session)
visitorBeacon.notify();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
)

